import { createBbDevToolsBridge } from './bridge.js';
import { createBbDevToolsUi } from './ui.js';
import { getBbIntegrationState } from '../bb/integration-state.js';

const MOUNT_HOOK_NAME = '__RS_BB_DEVTOOLS_MOUNT__';

export function createBbDevTools(rsSDK) {
  const bridge = createBbDevToolsBridge(rsSDK);
  const ui = createBbDevToolsUi({ bridge });
  let started = false;
  let mounted = false;

  if (typeof window !== 'undefined') {
    window[MOUNT_HOOK_NAME] = mountIfEnabled;
  }

  return {
    mountIfEnabled,
    wrapRsSDK,
  };

  function mountIfEnabled() {
    if (!getBbIntegrationState().debugUi) return;
    if (mounted) return;

    start();
    ui.mount();
    mounted = true;
  }

  function wrapRsSDK(base) {
    function devRsSDK(command) {
      if (command === 'bb:debug:open') {
        start();
        return ui.open();
      }

      if (command === 'bb:debug:close') {
        start();
        return ui.close();
      }

      if (command === 'bb:debug:toggle') {
        start();
        return ui.toggle();
      }

      if (command === 'bb:debug:snapshot') {
        start();
        return bridge.openSnapshot();
      }

      if (command === 'bb:debug:saves') {
        start();
        return bridge.getSaves();
      }

      if (command === 'bb:debug:reset-session') {
        start();
        return bridge.resetSession();
      }

      return base.apply(null, arguments);
    }

    copySdkProperties(base, devRsSDK);
    return devRsSDK;
  }

  function start() {
    if (started) return;

    bridge.install();
    started = true;
  }
}

function copySdkProperties(source, target) {
  const keys = Object.keys(source);
  for (let i = 0; i < keys.length; i++) {
    target[keys[i]] = source[keys[i]];
  }

  target.version = source.version;
  target.defaultEndpoint = source.defaultEndpoint;
}
